import { Box, Card, CardContent, Grid, Typography, useTheme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { VovClient } from '../../../../ApiOld/ApiServerVov';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../../ApiOld/Api/useApi';
import { WeatherInfoDTO } from '../../../../ApiOld/Api/ApiServerVov';

interface ProjectWeatherItemProps {
    weather: WeatherInfoDTO[];
    date: string;
}

export default function ProjectWeatherItem(props: ProjectWeatherItemProps) {
    const { weather, date } = props;
    const { t, i18n } = useTranslation();
    const { authorizedApi } = useApi(VovClient);

    const theme = useTheme();

    useEffect(() => {
        console.log(weather);
    }, [weather]);

    const findNearestTime = (data: WeatherInfoDTO[]) => {
        const now = new Date(); // Get the current date and time
        let closest = data[0];
        let closestDiff = Infinity; // Start with the largest possible difference

        data.forEach(item => {
            const [hour, minute] = item.time!.split(":").map(Number);
            const [day, month, year] = item.date!.split(".").map(Number);

            // Create a new Date object using the date and time
            const itemDate = new Date(year, month - 1, day, hour, minute);

            // Calculate the time difference between now and the item
            const diff = Math.abs(itemDate.getTime() - now.getTime());

            if (diff < closestDiff) {
                closestDiff = diff;
                closest = item;
            }
        });

        return closest;
    };

    const weatherItem = useMemo(() => (weather.length > 0 ? findNearestTime(weather) : undefined), [weather]);



    return (<Box style={{ marginTop: '0px', width: '100%', height: '100%', padding: '16px', minWidth: '330px' }} >
        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel sx={{ marginLeft: '24px', marginBottom: '0px', fontWeight: 'bold', marginTop: '8px' }}>{note.name}</FormLabel>
                <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                    <IconButton size='small' color="secondary" onClick={(e) => {
                        setOpenRenameDialog(true);
                    }}>
                        <Edit />
                    </IconButton>
                    <IconButton size='small' color="secondary" onClick={(e) => {
                        setDeleteDialogOpen(true)
                    }}>
                        <Delete />
                    </IconButton>
                </Box>
            </Box> */}
        {weatherItem && <Card sx={{ maxWidth: 500, margin: "auto", padding: 2, textAlign: "center", height: '100%' }}>
            <CardContent>
                <Typography variant="h6">{weatherItem.date}</Typography>
                <Typography variant="h4" sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                    <span>{weatherItem.temp}°C</span>
                    <img src={weatherItem.image} alt={weatherItem.title} />
                    {/* {getWeatherIcon(weatherItem.image ?? '')} */}
                </Typography>
                <Typography variant="subtitle1">{weatherItem.title}</Typography>
                {/* <Typography variant="body2" color="textSecondary">{weatherItem.city} {new Date().toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' })}</Typography> */}
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                    <Grid item xs={4}><Typography variant="body2">{t('WindSpeed')}</Typography><Typography variant="h6">{weatherItem.wind} m/s</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">{t('Humidity')}</Typography><Typography variant="h6">{weatherItem.humidity}%</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">{t('PrecipitationTotal')}</Typography><Typography variant="h6">{weather.reduce((sum, w) => sum + (w.rain3h ?? 0), 0).toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    })} mm</Typography></Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                    {weather.map((hour, index) => (
                        <Grid
                            item
                            xs={2}
                            key={index}
                            sx={{
                                textAlign: "center",
                                padding: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",  // Centers the content horizontally
                                justifyContent: "center" // Centers the content vertically
                            }}
                        >
                            <Typography variant="body2">{hour.time}</Typography>
                            {/* {getWeatherIcon(weatherItem.image ?? '')} */}
                            <img src={hour.image} alt={hour.title} />
                            <Typography variant="body2">{hour.temp}°C</Typography>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>}

    </Box>);
}
